// src/pages/goalbuddy/GoalBuddyWorkspace.tsx
import React from "react";
import { useLocation } from "react-router-dom";
import ServiceRailOmni from "@/components/rails/ServiceRailOmni";

// If you have a header that defines its height, adjust this number to match.
const HEADER_HEIGHT = 64;

export default function GoalBuddyWorkspace() {
  const loc = useLocation();

  return (
    <div className="mx-auto w-full max-w-[1400px] px-4 md:px-6 lg:px-8">
      <div className="grid grid-cols-12 gap-6">
        {/* LEFT: OmniCine rail (mirrored exactly) */}
        <aside
          className="col-span-12 md:col-span-3 lg:col-span-3 xl:col-span-3
                     sticky self-start"
          style={{ top: HEADER_HEIGHT }}
          aria-label="Services rail"
        >
          {/* Omni rail has no scrim/blur and matches OmniCine */}
          <ServiceRailOmni />
        </aside>

        {/* RIGHT: GoalBuddy content */}
        <main className="col-span-12 md:col-span-9 lg:col-span-9 xl:col-span-9">
          {/* —— Page header —— */}
          <section className="mb-4 rounded-2xl border border-white/10 bg-slate-900/70 text-white shadow-xl p-4">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-semibold">GoalBuddy</h1>
              {/* Action row kept from your UI (Proactive / Create / Spark / Settings etc.) */}
              <div className="flex items-center gap-2">
                <button className="rounded-xl border border-white/12 bg-white/5 px-3 py-1.5 text-sm">Proactive</button>
                <button className="rounded-xl border border-white/12 bg-white/5 px-3 py-1.5 text-sm">Create goal</button>
                <button className="rounded-xl border border-white/12 bg-white/5 px-3 py-1.5 text-sm">Spark</button>
                <button className="rounded-xl border border-white/12 bg-white/5 px-3 py-1.5 text-sm">Settings</button>
              </div>
            </div>
          </section>

          {/* —— Your existing GoalBuddy widgets go here —— */}
          {/* Keep your existing sections/components: devices row, vitals card, ingest, etc. */}
          <section className="mb-6">
            {/* Example stub container so the layout compiles; replace with your real components */}
            <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-4 text-white/90">
              {/* Place your GoalBuddy main content here */}
              <p className="text-sm opacity-80">
                GoalBuddy workspace content…
              </p>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}
